import React from 'react';
import { graphColors } from '../MatrixResult';

const MatrixLegend = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const cols = choices.filter(c => c.kind === 'column').sort((a, b) => a.position - b.position);

  return (
    <div className="survey-result-details-list">
      {cols.map((col, idx) => (
        <div key={col.id || col.position} className="details-list-row">
          <div className="details-list-left">
            <span
              className="survey-result-color-dot"
              style={{ backgroundColor: graphColors[idx % graphColors.length] }}
            />
            <span className="details-list-name">{col.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MatrixLegend;
